import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { ReportUserForm } from '../common/report-user-form'

import type { UserShort } from '@root/entities/user-short'
import type { DialogControlProps } from '@root/shared/ui-kit'

type ReportUserDialogProps = {
  user: UserShort.UserShort
} & DialogControlProps

export const ReportUserDialog = ({
  user,
  open,
  onOpenChange,
}: ReportUserDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      variant="bordered"
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('common.report')}
    >
      <Dialog.Header title={t('common.report')} />
      <Content>
        <Wrapper>
          <ReportUserForm user={user} onDone={() => onOpenChange?.(false)} />
        </Wrapper>
      </Content>
    </Dialog>
  )
}

const Content = styled.div`
  width: 360px;
`

const Wrapper = styled.div`
  background: var(--backgroundA-1);
  padding: 10px;
  border-radius: 12px;
`
